import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Checkbox, Collapse, Empty, Input, message, Tooltip } from 'antd'
import { inject, observer } from 'mobx-react'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  WARNING_MESSAGE,
} from '../../../constants'
import utils from '../../../utils'
import { CaretRightOutlined, SearchOutlined } from '@ant-design/icons'
import { BoxWrapper, PanelItem } from './SelectUserDepartmentBoxStyled'
import { EmptyText } from '../../Common/CellText'
import { AvatarHasName } from '../../Common/Avatar'
import { toJS } from 'mobx'

const SelectUserDepartmentBox = props => {
  const {
    defaultKeys,
    defaultActiveKey,
    setDefaultActiveKey,
    selectPeopleStore,
    departmentDisableList,
    userDisableList,
    onlyOneUser,
    isOpenCollapse,
    onlySelectOne,
    disableSelectDepartment,
    isVisibleSelectPeoplePopup,
    authenticationStore,
    isSendType, // dành riêng cho phần chọn người của văn bản đến, văn bản đi
    aclStore,
    selectedList,
    setCheckCancel,
  } = props

  const {
    departmentWithUserList,
    setDepartmentWithUserList,
    originDepartmentWithUserList,
    assigneePopupType,
    selectUserData,
    selectDepartmentData,
    setSelectUserData,
    setSelectDepartmentData,
  } = selectPeopleStore

  const { currentUser } = authenticationStore
  const { aclActionsByUser } = aclStore

  const [newDepartmentWithUserList, setNewDepartmentWithUserList] = useState([])
  const [currentUserActionList, setCurrentUserActionList] = useState([])
  const [isClerk, setIsClerk] = useState(false) // check quyền văn thư

  useEffect(() => {
    const targetCodes = new Set([
      ACL_ACTION_TYPE.them_nguoi_INCOMING,
      ACL_ACTION_TYPE.them_nguoi_OUTGOING,
      ACL_ACTION_TYPE.them_nguoi_cung_phong_ban_INCOMING,
      ACL_ACTION_TYPE.them_nguoi_cung_phong_ban_OUTGOING,
    ])

    const currentAclActions = aclActionsByUser.filter(
      item => targetCodes.has(item.code) && item.status === true
    )
    setCurrentUserActionList(currentAclActions)

    // Tạo Set chứa các code hiện có để dễ kiểm tra
    const currentCodes = new Set(currentAclActions.map(item => item.code))
    const hasIncoming = currentCodes.has(ACL_ACTION_TYPE.them_nguoi_INCOMING)
    const hasOutgoing = currentCodes.has(ACL_ACTION_TYPE.them_nguoi_OUTGOING)

    if (isSendType) {
      if (hasIncoming && hasOutgoing) {
        setIsClerk(true)
        setCheckCancel(true)
        setNewDepartmentWithUserList(departmentWithUserList)
      } else {
        const newDepartmentWithUserList = departmentWithUserList.filter(
          department => department.code === currentUser?.department?.code
        )
        setNewDepartmentWithUserList(newDepartmentWithUserList)
      }
    } else {
      setNewDepartmentWithUserList(departmentWithUserList)
    }
  }, [departmentWithUserList, aclActionsByUser, isSendType, currentUser])

  // const handleSelectUser = useCallback(
  //   user => {
  //     if (!assigneePopupType || !user) return

  //     if (onlySelectOne) {
  //       selectPeopleStore.clearSelectedByType(assigneePopupType)
  //       setSelectUserData({
  //         ...selectUserData,
  //         [assigneePopupType]: [
  //           {
  //             assignee_type: ASSIGNEE_TYPE.USER,
  //             full_name: user.name_uppercase,
  //             id: user.user_name,
  //             permission: assigneePopupType,
  //             department_code: user.department_code,
  //             department_name: user.department_name,
  //             image_id: user.image_id,
  //             position_name: user.position_name,
  //             create_user: user?.create_user ?? null,
  //           },
  //         ],
  //       })
  //       return
  //     }

  //     const departmentOfUser = originDepartmentWithUserList.find(
  //       el => el.code === user.department_code
  //     )
  //     const userList = departmentOfUser.users.map(user => ({
  //       ...user,
  //       department_code: departmentOfUser.code,
  //       department_name: departmentOfUser.name,
  //     }))
  //     const isSelectedUser = selectUserData[assigneePopupType]?.some(
  //       el => el.id === user.user_name
  //     )
  //     const isDepartmentOfUserSelected = selectDepartmentData[
  //       assigneePopupType
  //     ]?.some(el => el.id === user.department_code)
  //     if (isSelectedUser || isDepartmentOfUserSelected) {
  //       if (isDepartmentOfUserSelected) {
  //         setSelectDepartmentData({
  //           ...selectDepartmentData,
  //           [assigneePopupType]: selectDepartmentData[assigneePopupType].filter(
  //             el => el.id !== user.department_code
  //           ),
  //         })
  //         setSelectUserData({
  //           ...selectUserData,
  //           [assigneePopupType]: [
  //             ...selectUserData[assigneePopupType],
  //             ...userList
  //               .filter(el => el.user_name !== user.user_name)
  //               .map(el => ({
  //                 assignee_type: ASSIGNEE_TYPE.USER,
  //                 full_name: el.name_uppercase,
  //                 id: el.user_name,
  //                 permission: assigneePopupType,
  //                 department_code: el.department_code,
  //                 department_name: el.department_name,
  //                 image_id: el.image_id,
  //                 position_name: el.position_name,
  //                 create_user: el?.create_user ?? null,
  //               })),
  //           ],
  //         })
  //         return
  //       }
  //       setSelectUserData({
  //         ...selectUserData,
  //         [assigneePopupType]: selectUserData[assigneePopupType].filter(
  //           el => el.id !== user.user_name
  //         ),
  //       })
  //       return
  //     }
  //     setSelectUserData({
  //       ...selectUserData,
  //       [assigneePopupType]: [
  //         ...selectUserData[assigneePopupType],
  //         {
  //           assignee_type: ASSIGNEE_TYPE.USER,
  //           full_name: user.name_uppercase,
  //           id: user.user_name,
  //           permission: assigneePopupType,
  //           department_code: user.department_code,
  //           department_name: user.department_name,
  //           image_id: user.image_id,
  //           position_name: user.position_name,
  //           create_user: user?.create_user ?? null,
  //         },
  //       ],
  //     })
  //   },
  //   [
  //     assigneePopupType,
  //     selectUserData,
  //     selectDepartmentData,
  //     originDepartmentWithUserList,
  //     onlySelectOne,
  //   ]
  // )

  const handleSelectUser = useCallback(
    user => {
      if (!assigneePopupType || !user) return

      const isSelectedUser = selectUserData[assigneePopupType]?.some(
        el => el.id === user.user_name
      )

      // Nếu user đã được chọn => bỏ chọn
      if (isSelectedUser) {
        setSelectUserData({
          ...selectUserData,
          [assigneePopupType]: selectUserData[assigneePopupType].filter(
            el => el.id !== user.user_name
          ),
        })
        return
      }

      // Nếu onlySelectOne = true, bỏ chọn tất cả trước khi thêm mới
      const newUserData = onlySelectOne
        ? [
            {
              assignee_type: ASSIGNEE_TYPE.USER,
              full_name: user.name_uppercase,
              id: user.user_name,
              permission: assigneePopupType,
              department_code: user.department_code,
              department_name: user.department_name,
              image_id: user.image_id,
              position_name: user.position_name,
              create_user: user?.create_user ?? null,
            },
          ]
        : [
            ...(selectUserData[assigneePopupType] || []),
            {
              assignee_type: ASSIGNEE_TYPE.USER,
              full_name: user.name_uppercase,
              id: user.user_name,
              permission: assigneePopupType,
              department_code: user.department_code,
              department_name: user.department_name,
              image_id: user.image_id,
              position_name: user.position_name,
              create_user: user?.create_user ?? null,
            },
          ]

      setSelectUserData({
        ...selectUserData,
        [assigneePopupType]: newUserData,
      })

      // Nếu onlySelectOne = true, bỏ chọn department
      if (onlySelectOne) {
        setSelectDepartmentData({
          ...selectDepartmentData,
          [assigneePopupType]: [],
        })
      }
    },
    [assigneePopupType, selectUserData, selectDepartmentData, onlySelectOne]
  )

  const [valueSearch, setValueSearch] = useState('')

  useEffect(() => {
    setValueSearch('')
  }, [isVisibleSelectPeoplePopup])

  // const handleSelectDepartment = useCallback(
  //   department => {
  //     const findDepartment = selectedList?.find(
  //       el => el?.id === department?.code
  //     )
  //     if (!assigneePopupType || !department) return

  //     if (
  //       findDepartment &&
  //       findDepartment.create_user !== currentUser.user_name &&
  //       !isClerk
  //     ) {
  //       message.warning(WARNING_MESSAGE.WARNING_DOCUMENT)
  //       return
  //     }

  //     if (onlySelectOne) {
  //       selectPeopleStore.clearSelectedByType(assigneePopupType)
  //       setSelectDepartmentData({
  //         ...selectDepartmentData,
  //         [assigneePopupType]: [
  //           {
  //             assignee_type: ASSIGNEE_TYPE.DEPARTMENT,
  //             full_name: department.name,
  //             id: department.code,
  //             permission: assigneePopupType,
  //           },
  //         ],
  //       })
  //       return
  //     }

  //     const isSelectedDepartment = selectDepartmentData[
  //       assigneePopupType
  //     ]?.some(el => el.id === department.code)
  //     if (isSelectedDepartment) {
  //       setSelectDepartmentData({
  //         ...selectDepartmentData,
  //         [assigneePopupType]: selectDepartmentData[assigneePopupType].filter(
  //           el => el.id !== department.code
  //         ),
  //       })
  //       setSelectUserData({
  //         ...selectUserData,
  //         [assigneePopupType]: selectUserData[assigneePopupType].filter(
  //           el => el.department_code !== department.code
  //         ),
  //       })
  //       return
  //     }
  //     setSelectDepartmentData({
  //       ...selectDepartmentData,
  //       [assigneePopupType]: [
  //         ...selectDepartmentData[assigneePopupType],
  //         {
  //           assignee_type: ASSIGNEE_TYPE.DEPARTMENT,
  //           full_name: department.name,
  //           id: department.code,
  //           permission: assigneePopupType,
  //         },
  //       ],
  //     })
  //     setSelectUserData({
  //       ...selectUserData,
  //       [assigneePopupType]: selectUserData[assigneePopupType].filter(
  //         el => el.department_code !== department.code
  //       ),
  //     })
  //   },
  //   [
  //     assigneePopupType,
  //     selectUserData,
  //     selectDepartmentData,
  //     onlySelectOne,
  //     selectedList,
  //   ]
  // )

  const handleSelectDepartment = useCallback(
    department => {
      if (!assigneePopupType || !department) return

      const isSelectedDepartment = selectDepartmentData[
        assigneePopupType
      ]?.some(el => el.id === department.code)

      // Nếu department đã được chọn => bỏ chọn
      if (isSelectedDepartment) {
        setSelectDepartmentData({
          ...selectDepartmentData,
          [assigneePopupType]: selectDepartmentData[assigneePopupType].filter(
            el => el.id !== department.code
          ),
        })
        return
      }

      // Nếu onlySelectOne = true, bỏ chọn tất cả trước khi thêm mới
      const newDepartmentData = onlySelectOne
        ? [
            {
              assignee_type: ASSIGNEE_TYPE.DEPARTMENT,
              full_name: department.name,
              id: department.code,
              permission: assigneePopupType,
            },
          ]
        : [
            ...(selectDepartmentData[assigneePopupType] || []),
            {
              assignee_type: ASSIGNEE_TYPE.DEPARTMENT,
              full_name: department.name,
              id: department.code,
              permission: assigneePopupType,
            },
          ]

      setSelectDepartmentData({
        ...selectDepartmentData,
        [assigneePopupType]: newDepartmentData,
      })

      // Nếu onlySelectOne = true, bỏ chọn user
      if (onlySelectOne) {
        setSelectUserData({
          ...selectUserData,
          [assigneePopupType]: [],
        })
      }
    },
    [assigneePopupType, selectUserData, selectDepartmentData, onlySelectOne]
  )

  const onSearchUser = useCallback(
    event => {
      setDefaultActiveKey(defaultKeys)
      setValueSearch(event.target.value)
      if (event.target.value.trim() === '') {
        setDepartmentWithUserList(originDepartmentWithUserList)
        return
      }
      const filterList = originDepartmentWithUserList
        .map(department => {
          const newUserList = department.users.filter(user =>
            utils
              .nonAccentVietnamese(user.name_uppercase)
              .includes(utils.nonAccentVietnamese(event.target.value))
          )
          return {
            ...department,
            users: newUserList,
          }
        })
        .filter(department => department.users.length > 0)
      setDepartmentWithUserList(filterList)
    },
    [originDepartmentWithUserList, defaultKeys]
  )

  const handleSelectOnlyOneUser = useCallback(
    user => {
      if (!assigneePopupType || !user) return
      const isSelectedUser = selectUserData[assigneePopupType]?.some(
        el => el.id === user.user_name
      )
      if (isSelectedUser) {
        setSelectUserData({
          ...selectUserData,
          [assigneePopupType]: [],
        })
        return
      }
      setSelectUserData({
        ...selectUserData,
        [assigneePopupType]: [
          {
            assignee_type: ASSIGNEE_TYPE.USER,
            full_name: user.name_uppercase,
            id: user.user_name,
            permission: assigneePopupType,
            department_code: user.department_code,
            department_name: user.department_name,
            image_id: user.image_id,
            position_name: user.position_name,
            create_user: user?.create_user ?? null,
          },
        ],
      })
    },
    [assigneePopupType, selectUserData]
  )

  const onChangeCollapse = keys => {
    setDefaultActiveKey(keys)
  }

  useEffect(() => {
    if (isOpenCollapse) {
      setDefaultActiveKey(defaultKeys)
    } else {
      setDefaultActiveKey([])
    }
  }, [isOpenCollapse, defaultKeys])

  const renderUserItem = (user, department, disabled, title) => {
    const checked =
      (assigneePopupType &&
        selectUserData[assigneePopupType]?.some(
          el => el.id === user.user_name
        )) ||
      (assigneePopupType &&
        selectDepartmentData[assigneePopupType]?.some(
          el => el.id === department.code
        ))

    return (
      <Tooltip key={user.user_name} title={title}>
        <div
          className={`user-item ${checked ? 'user-item-checked' : ''} ${
            disabled ? 'user-item-disabled' : ''
          }`}
          onClick={() => {
            if (disabled) return
            const userData = {
              ...user,
              department_code: department.code,
              department_name: department.name,
            }
            const findUser = selectedList?.find(
              el => el?.id === userData?.user_name
            )
            if (
              findUser &&
              findUser.create_user !== null &&
              findUser.create_user !== currentUser.username &&
              !isClerk
            ) {
              message.warning(WARNING_MESSAGE.WARNING_DOCUMENT)
              return
            }
            onlyOneUser
              ? handleSelectOnlyOneUser(userData)
              : handleSelectUser(userData)
          }}>
          <Checkbox checked={checked} disabled={disabled} />
          <div className="user-item-info">
            <AvatarHasName
              name={user.name_uppercase}
              position={user.position_name}
              imgId={user.image_id}
            />
          </div>
        </div>
      </Tooltip>
    )
  }

  return (
    <BoxWrapper>
      <div className={'search-box'}>
        <Input
          value={valueSearch}
          allowClear
          suffix={<SearchOutlined />}
          placeholder={'Tìm theo tên người dùng'}
          onChange={event => onSearchUser(event)}
          style={{ width: '100%' }}
        />
      </div>
      <div className={'collapse-wrapper'}>
        <Collapse
          onChange={onChangeCollapse}
          activeKey={defaultActiveKey}
          collapsible={'header'}
          expandIcon={({ isActive }) => (
            <CaretRightOutlined rotate={isActive ? 90 : 0} />
          )}>
          {newDepartmentWithUserList.map((department, index) => {
            const checked =
              assigneePopupType &&
              selectDepartmentData[assigneePopupType].some(
                el => el.id === department.code
              )
            const disabled =
              departmentDisableList.includes(department.code) ||
              (isSendType && !(currentUserActionList.length > 0)) // thêm điều kiện cho văn bản đến, đi (isSendType). currentUserActionList là những quyền thêm người

            return (
              <PanelItem
                checked={checked}
                collapsible
                key={index}
                header={
                  <Tooltip
                    title={
                      disabled && !onlyOneUser
                        ? 'Phòng ban này đã được chọn'
                        : null
                    }>
                    <div
                      onClick={e => {
                        if (onlyOneUser || disableSelectDepartment) return
                        e.stopPropagation()
                        if (disabled) return
                        handleSelectDepartment(department)
                      }}
                      className={`department-title ${
                        checked && 'department-title-checked'
                      } ${
                        ((disabled && !onlyOneUser) ||
                          (disabled && !disableSelectDepartment)) &&
                        'department-title-disabled'
                      }`}>
                      {!onlyOneUser && !disableSelectDepartment && (
                        <Checkbox checked={checked} disabled={disabled} />
                      )}
                      <span className={'department-name'}>
                        {department.name}
                      </span>
                    </div>
                  </Tooltip>
                }>
                {department.users.length > 0 ? (
                  <>
                    {department.users.map(user => {
                      const isUserDisabled = userDisableList.includes(
                        user.user_name
                      )
                      const hasUserAction = currentUserActionList?.length > 0

                      let title = null
                      let disabled = false

                      if (isSendType) {
                        // dành riêng cho phần chọn người của văn bản đến, văn bản đi
                        if (!hasUserAction) {
                          title = 'Bạn không có quyền chọn người dùng'
                          disabled = true
                        } else if (isUserDisabled) {
                          title = 'Người dùng này đã được chọn'
                          disabled = true
                        }
                      } else if (isUserDisabled) {
                        // nếu người dùng đã được chọn rồi
                        title = 'Người dùng này đã được chọn'
                        disabled = true
                      }

                      return renderUserItem(user, department, disabled, title)
                    })}
                  </>
                ) : (
                  <div style={{ padding: '10px 0 10px 60px' }}>
                    <EmptyText>Không có người dùng</EmptyText>
                  </div>
                )}
              </PanelItem>
            )
          })}
        </Collapse>
        {newDepartmentWithUserList.length === 0 && (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={'Không có dữ liệu'}
            />
          </div>
        )}
      </div>
    </BoxWrapper>
  )
}

SelectUserDepartmentBox.propTypes = {
  disableUserDepartmentList: PropTypes.array,
}

export default inject(
  'selectPeopleStore',
  'loadingAnimationStore',
  'authenticationStore',
  'aclStore'
)(observer(SelectUserDepartmentBox))
